var $ = require("jquery");
global.jQuery = require("jquery");

import "../css/site.scss";

require("jquery-validation-unobtrusive");
require("./bankid");
require("./error-handling");
require("./state-management");

const objectFitImages = require("object-fit-images");

import { setErrorMessage } from "./error-handling";
import { setDefaultLoginState } from "./state-management";
import { successState, loginMethod, pushLogin, pushTestAccountCreation } from "./datalayer-helper";

$(".js-expand-toggle-btn").on("click", function () {
	var expandBtn = $(this);
	var expandInfo = $(".js-expand-info");

	if (expandInfo.hasClass("expanded")) {
		expandBtn.removeClass("expanded");
		expandInfo.slideUp("1000", function () {
			expandInfo.removeClass("expanded");
		});
	} else {
		expandBtn.addClass("expanded");
		expandInfo.slideDown("1000", function () {
			expandInfo.addClass("expanded");
		});
	}
});

const tabs = $(".js-tab-button");

tabs.on("click", function () {
	if ($(this).hasClass("selected")) {
		return;
	}
	$(this).addClass("selected");
	$(this).siblings().removeClass("selected");

	$(`#${$(this).data("tab")}`).addClass("selected");
	$(`#${$(this).data("tab")}`)
		.siblings()
		.removeClass("selected");
});

$(".js-login-choice").on("click", function () {
	$(".js-choice-container").hide();
	$(".js-bottom-group").hide();
});

$("#login-back-button").on("click", function () {
	setDefaultLoginState();
});

$("#form-login").on("submit", function (e) {
	e.preventDefault();
	$.ajax({
		url: $(this).action,
		method: "post",
		data: $(this).serialize(),
	})
		.done(function (res) {
			pushLogin(successState.Successful, loginMethod.Username);
			window.location.href = res.returnUrl;
		})
		.fail(function (res) {
			pushLogin(successState.Unsuccessful, loginMethod.Username);
			setErrorMessage(res.responseText);
			$(e.target).find("input").removeClass("readonly");
			$(e.originalEvent.submitter).toggleClass("loading");
		});
});

$("form").on("submit", function (e) {
	if ($(this).valid()) {
		$(this).find("input").toggleClass("readonly");
		$(e.originalEvent.submitter).toggleClass("loading");
	}
});

$("#AcceptsGdpr").on("change", function () {
	var gdprApproved = document.getElementById("AcceptsGdpr").checked;
	if (gdprApproved) {
		$(".checkbox").addClass("checked");
	} else {
		$(".checkbox").removeClass("checked");
	}
});

$("#AgreeActivation").on("change", function () {
	if (this.checked) {
		$(".checkbox").addClass("checked");
		$("#bankid-activate").toggleClass("disabled").removeAttr("disabled");
	} else {
		$(".checkbox").removeClass("checked");
		$("#bankid-activate").toggleClass("disabled").attr("disabled", true);
	}
});

$(document).on("ready", function () {
	objectFitImages();
});

$("#DemoRegistrationForm").on("submit", function () {
	if ($(this).valid()) {
		pushTestAccountCreation();
	}
});

